/**
 * BrowserRouter: This is a copy of the BrowserRouter provided by react-router
 * but modified to support updating the history object when the props change.
 * This allows us to update `forceRefresh` dynamically.
 *
 * This history module doesn't support setForceRefresh by default but it was
 * added in this PR, which is what we're using:
 * https://github.com/ReactTraining/history/pull/614
 *
 * Original BrowserRouter code:
 * https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/modules/BrowserRouter.js
 */

import {createBrowserHistory as createHistory} from "history";
import * as React from "react";
import {Router} from "react-router";
import {CompatRouter} from "react-router-dom-v5-compat";

type Props = {
    /**
     * Turn on/off forcing the browser to refresh when the user navigates.
     */
    forceRefresh?: boolean;
    children: React.ReactNode;
};

export default class BrowserRouter extends React.Component<Props> {
    componentDidUpdate(prevProps: Props) {
        if (this.props.forceRefresh !== prevProps.forceRefresh) {
            this.history.setForceRefresh(this.props.forceRefresh);
        }
    }

    history: any = createHistory(this.props);

    render(): React.ReactNode {
        return (
            <Router history={this.history}>
                <CompatRouter>{this.props.children}</CompatRouter>
            </Router>
        );
    }
}
